import giftcertificateModule from '../scripts/giftcertificate/giftcertificate.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(giftcertificateModule);